import { firebaseApp } from "config/firebase";
import { getFunctions, httpsCallable } from "firebase/functions";
import { intercomServiceConfig } from "./IntercomService.config";

interface HMACRequestType {
  clientType: "Web";
}

interface AssetResponseType {
  hmac: string;
}

class IntercomService {
  static async getSigningToken(): Promise<string> {
    const functions = getFunctions(firebaseApp, intercomServiceConfig.region);
    const getIntercomHMAC = httpsCallable<HMACRequestType, AssetResponseType>(functions, "intercom-hmac-signing");

    const { data } = await getIntercomHMAC({ clientType: "Web" });
    return data.hmac;
  }
}

export default IntercomService;
